import {useLocalStorageNew} from "./useLocalStorageNew";
import {useContext} from "react";
import {YuJaGlobalState} from "../utils/LoadingContext";

export default function useHostResource(hostname) {
    const {setGlobalHostResource} = useContext(YuJaGlobalState);
    const [setHostResource, getHostResource] = useLocalStorageNew(hostname, {});

    const updateImageURL = (imageURL="") => {
        const hostResource = getHostResource();
        hostResource.imageURL = imageURL;
        setHostResource(hostResource);
        setGlobalHostResource(hostResource);
    }

    const updateLogoImageURL = (imageURL="") => {
        const hostResource = getHostResource();
        hostResource.logoImageURL = imageURL;
        setHostResource(hostResource);
        setGlobalHostResource(hostResource);
    }


    const updatePlatformSetting= (platformSetting={}) => {
        const hostResource = getHostResource();
        hostResource.platformSetting = platformSetting;
        setHostResource(hostResource);
        setGlobalHostResource(hostResource);
    }

    const updateSSOConfig= (ssoConfig={}) => {
        const hostResource = getHostResource();
        hostResource.ssoConfig = ssoConfig;
        setHostResource(hostResource);
        setGlobalHostResource(hostResource);
    }


    const updateIntegrationType = (configObj={}, intType) => {
        const hostResource = getHostResource();
        if (!hostResource.hasOwnProperty("ssoConfig")) {
            hostResource.ssoConfig = {};
        }

        hostResource.ssoConfig[intType] = JSON.stringify(configObj);
        setHostResource(hostResource);
        setGlobalHostResource(hostResource);
    }


    return {updateImageURL, updateLogoImageURL, updatePlatformSetting, updateSSOConfig, updateIntegrationType};
}